import { ONE_MB } from '@main/utils';

export const SKIP_PRIVACY_CENTER_MODULES_FLAG_KEY =
  'skipPrivacyCenterStaticModules';

// penumbra fails authTag checks for larger files
export const PENUMBRA_IGNORE_AUTH_TAG_THRESHOLD = 450 * ONE_MB;
